import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Shield, ClipboardList, BookOpen, Sparkles,
  Dumbbell, BookMarked, Film, TrendingUp, Bot, Calendar,
  FolderOpen, MessageSquare, Brain, Users, LogOut, CreditCard, UserSquare2
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { section: "Command" },
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/ai-coach", label: "AI Football Coach", icon: Bot, testid: "nav-ai-coach" },
  { section: "Program" },
  { to: "/program-identity", label: "Program Identity", icon: Shield, testid: "nav-identity" },
  { to: "/staff-manual", label: "Staff Manual", icon: Users, testid: "nav-staff-manual" },
  { to: "/player-handbook", label: "Player Handbook", icon: BookOpen, testid: "nav-player-handbook" },
  { to: "/culture", label: "Culture Builder", icon: Sparkles, testid: "nav-culture" },
  { section: "Football" },
  { to: "/practice-planner", label: "Practice Planner", icon: ClipboardList, testid: "nav-practices" },
  { to: "/drill-library", label: "Drill Library", icon: Dumbbell, testid: "nav-drills" },
  { to: "/playbook", label: "Playbook", icon: BookMarked, testid: "nav-playbook" },
  { to: "/film-hub", label: "Film Hub", icon: Film, testid: "nav-film" },
  { to: "/roster", label: "Team Roster", icon: UserSquare2, testid: "nav-roster" },
  { to: "/player-development", label: "Player Development", icon: TrendingUp, testid: "nav-development", soon: true },
  { section: "Program Ops" },
  { to: "/calendar", label: "Calendar", icon: Calendar, testid: "nav-calendar", soon: true },
  { to: "/documents", label: "Documents", icon: FolderOpen, testid: "nav-documents", soon: true },
  { to: "/messaging", label: "Messaging", icon: MessageSquare, testid: "nav-messaging" },
  { to: "/knowledge-base", label: "Knowledge Base", icon: Brain, testid: "nav-kb", soon: true },
  { section: "Account" },
  { to: "/settings/billing", label: "Billing & Seats", icon: CreditCard, testid: "nav-billing" },
  { to: "/pricing", label: "Pricing", icon: Sparkles, testid: "nav-pricing" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  return (
    <aside className="w-[248px] shrink-0 border-r border-surface-3 bg-[#0B0D12] flex flex-col h-screen sticky top-0" data-testid="sidebar">
      {/* Brand */}
      <div className="px-5 py-5 border-b border-surface-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-amber flex items-center justify-center" data-testid="brand-mark">
            <span className="font-display text-[#0B0D12] text-xl leading-none">G</span>
          </div>
          <div>
            <div className="font-display text-2xl leading-none tracking-widest text-white">GRIDIRON</div>
            <div className="font-condensed text-[10px] tracking-[0.35em] text-amber uppercase mt-0.5">Operating System</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto py-3 px-2">
        {NAV.map((item) => {
          if (item.section) {
            return (
              <div key={`sec-${item.section}`} className="px-3 pt-4 pb-2 text-[10px] font-condensed tracking-[0.3em] uppercase text-slate-500">
                {item.section}
              </div>
            );
          }
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={item.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2 mb-0.5 text-sm font-medium transition-colors border-l-2 ${
                  isActive
                    ? "border-amber bg-surface text-white"
                    : "border-transparent text-slate-400 hover:text-white hover:bg-surface"
                }`
              }
            >
              <Icon className="w-4 h-4 shrink-0" strokeWidth={2} />
              <span className="flex-1">{item.label}</span>
              {item.soon && (
                <span className="text-[9px] font-condensed tracking-widest text-amber/70 uppercase">Soon</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* User */}
      <div className="border-t border-surface-3 p-3">
        <div className="flex items-center gap-3 px-2 py-2 bg-surface" data-testid="user-block">
          <div className="w-8 h-8 bg-amber/20 border border-amber/40 flex items-center justify-center">
            <span className="font-display text-amber text-sm">
              {(user?.name || "C").split(" ").map(s => s[0]).join("").slice(0,2).toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold truncate">{user?.name || "Coach"}</div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500 truncate">
              {(user?.title || user?.role || "").replace(/_/g, " ")}
            </div>
          </div>
          <button
            onClick={logout}
            className="text-slate-500 hover:text-amber p-1 transition-colors"
            data-testid="logout-btn"
            title="Sign out"
          >
            <LogOut className="w-4 h-4" />
          </button>
        </div>
      </div>
    </aside>
  );
}
